module.exports = __webpack_public_path__ + "img/funny.4bad307c.gif";